import DataApi from './DataApi';

class VisitMobileConfigApi extends DataApi {
  constructor() {
    super('visit_mobile_config');
  }

  list(includeInactive = false) {
    return this.fetchAll(includeInactive ? 'includeInactive=true' : '');
  }

  fetchByObjectAndKey(objectName, configKey) {
    return this.get(
      `/${encodeURIComponent(objectName)}/${encodeURIComponent(configKey)}`
    );
  }

  save(payload) {
    if (payload?.id) {
      return this.put(`/${payload.id}`, payload);
    }
    return this.post('', payload);
  }

  deleteConfig(id) {
    return this.delete(id);
  }
}

export default VisitMobileConfigApi;
